module.exports = __webpack_public_path__ + "static/media/escape.179f7e55.svg";